import { Injectable } from '@angular/core';
import { AppComponent } from '../app.component';

@Injectable({
  providedIn: 'root'
})
export class AlertService {

  protected appComponent: AppComponent;

  constructor() { }

  showError(title: string, text: string) {
    this.appComponent.showError(title, text);
  }

  showSuccess(title: string, text: string) {
    this.appComponent.showSuccess(title, text);
  }

  setComponent(component: AppComponent) {
    this.appComponent = component;
  }
}
